import extend from 'lodash/extend';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const { actions, reducer } = createSlice({
	name: 'consent',
	initialState,
	reducers: {
		createConsent: (state) => extend(state, { loading: true, error: null }),
		createConsentFailure: (state, { payload }) =>
			extend(state, { loading: false, error: payload }),
		// createConsentSuccess: (state, { payload }) =>
		// 	extend(state, { loading: false, error: null, data: payload }),
		createConsentSuccess: (state, { payload }) => {
			const consent = payload;
			window.parent.postMessage(
				JSON.stringify({ type: 'CONSENT_CHANGED', data: consent }),
				'*',
			);
			return extend(state, { loading: false, error: null, data: consent });
		},

		updateConsent: (state) => extend(state, { loading: true, error: null }),
		updateConsentFailure: (state, { payload }) =>
			extend(state, { loading: false, error: payload }),
		// updateConsentSuccess: (state, { payload }) =>
		// 	extend(state, { loading: false, error: null, data: payload }),
		updateConsentSuccess: (state, { payload }) => {
			const consent = payload;
			window.parent.postMessage(
				JSON.stringify({ type: 'CONSENT_CHANGED', data: consent }),
				'*',
			);
			return extend(state, { loading: false, error: null, data: consent });
		},

		getConsent: (state) => extend(state, { loading: true, error: null }),
		getConsentFailure: (state, { payload }) =>
			extend(state, { loading: false, error: payload }),
		// getConsentSuccess: (state, { payload }) =>
		// 	extend(state, { loading: false, error: null, data: payload }),
		getConsentSuccess: (state, { payload }) => {
			window.parent.postMessage(
				JSON.stringify({ type: 'CONSENT_CHANGED', data: payload }),
				'*',
			);
			return extend(state, { loading: false, error: null, data: payload });
		},
	},
});

export const {
	createConsent,
	createConsentSuccess,
	createConsentFailure,
	updateConsent,
	updateConsentSuccess,
	updateConsentFailure,
	getConsent,
	getConsentSuccess,
	getConsentFailure,
} = actions;

export { default as consentSaga } from './sagas';

export default reducer;
